import React, { useContext } from "react";
import { Route, Navigate, Outlet } from "react-router-dom";
import AuthContext from "../context/AuthContext";

const PrivateRoute = ({ children, ...rest }) => {
  let { user } = useContext(AuthContext);
  return user ? children : <Navigate to="/login-page" />;
};

export default PrivateRoute;
